import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const $root = document.getElementById('mtm-wrap');

if ($root) {
  ReactDOM.render(<App />, $root);
}



// WEBPACK FOOTER //
// ./src/index.js